<template>
    <div class="google-autocomplete-container">
        <input v-model="autocompleteInput" ref="autocomplete"
               v-bind:placeholder="placeholder"
               v-bind:class="className"
               :disabled="location != null"
               autocomplete="off"
               class="form-control"
               @click="selectedIndex = -1"
               type="text" />

        <div class="google-autocomplete-reset" v-if="location != null"
             :class="{disabled: disabled}"
             v-on:click="reset()">
            <iconify-icon class="icono" icon="iconoir:cancel"></iconify-icon>
        </div>

        <ul ref="optionlist" class="buscador-direccion" :class="{hidden: autocompleteInput.length < 1}">
            <li v-if="filtrando" class="text-center" style="padding-left: 0; padding-right: 0;">
                <span>Buscando...</span>
            </li>
            <li v-show="!filtrando" v-if="text() == ''" v-for="(place, index) in defaultAdresses"
                v-on:click="selectPlace(place)"
                :class="{active: index == selectedIndex}">
                <iconify-icon class="icono" icon="carbon:location-filled"></iconify-icon>
                <span>{{ place.description }}</span>
            </li>
            <li v-show="!filtrando" v-if="text() != ''" v-for="(place, index) in places" v-on:click="selectPlace(place)"
            :class="{active: index == selectedIndex}">
                <iconify-icon class="icono" icon="carbon:location-filled"></iconify-icon>
                <span>{{ place.description }}</span>
            </li>
        </ul>

    </div>
</template>

<script>

    // let map;

    export default {
        props:{
            value: Object,
            placeholder: String,
            className: String,
            disabled: {
              type: Boolean,
              value: false,
            },
        },
        data() {
            return {
                filtrando: false,
                selectedIndex: -1,
                autocompleteInput: "",
                defaultAdresses: [],
                map: null,
                places: [],
                apiKey: null,
                sessionToken: null,
                location: null,
                keyUpTimeout: null, // evita consultas al autocomplete mientras se esta escribiendo
            }
        },
        mounted() {

        },
        methods:{
            init(map){
                let vueComponent = this;
                this.map = map;
                this.sessionToken = (new Date()).getTime();

                this.$refs.autocomplete.addEventListener("keyup", (e) => {
                    if(e.keyCode == 40 || e.keyCode == 38){
                        if(vueComponent.text() == ''){
                            if(e.keyCode == 40){
                                if(vueComponent.selectedIndex < vueComponent.defaultAdresses.length - 1){
                                    vueComponent.selectedIndex++;
                                }
                            }
                            else{
                                if(vueComponent.defaultAdresses.length > 0){
                                    if(vueComponent.selectedIndex > -1){
                                        vueComponent.selectedIndex--;
                                    }
                                }
                            }

                        }
                        else if(vueComponent.text() != ''){
                            if(e.keyCode == 40) {
                                if (vueComponent.selectedIndex < vueComponent.places.length - 1) {
                                    vueComponent.selectedIndex++;
                                }
                            }
                            else{
                                if(vueComponent.places.length > 0){
                                    if(vueComponent.selectedIndex > -1){
                                        vueComponent.selectedIndex--;
                                    }
                                }
                            }
                        }
                    }
                    else if(e.keyCode == 13){
                        if(vueComponent.selectedIndex > -1){
                            if(vueComponent.text() == ''){
                                vueComponent.selectPlace(vueComponent.defaultAdresses[vueComponent.selectedIndex]);
                            }
                            else if(vueComponent.text() != ''){
                                vueComponent.selectPlace(vueComponent.places[vueComponent.selectedIndex]);
                            }
                        }
                    }
                    else{
                        clearTimeout(vueComponent.keyUpTimeout);
                        vueComponent.keyUpTimeout = setTimeout(() => {
                            vueComponent.autocomplete(vueComponent.$refs.autocomplete.value);
                        }, 250);
                    }
                });

                this.$refs.autocomplete.addEventListener("focus", () => {
                    this.$refs.optionlist.style.display = "block";
                });

                this.$refs.autocomplete.addEventListener("blur", () => {
                    setTimeout(function(){
                      vueComponent.$refs.optionlist.style.display = "none";
                    }, 1000);
                });
            },
            manualSelect(){
              if(!this.disabled){
                this.$emit("manual-select")
              }
            },
            reset(){
                if(this.disabled){
                  return;
                }
                this.location = null;
                this.autocompleteInput = '';
                this.$emit("input", this.location);
                this.$emit('change')
            },
            autocomplete(search){
                let url = "/buscador-ubicacion?"
                    + "&location=" + this.map.getCenter().lat() + "," + this.map.getCenter().lng()
                    + "&sessiontoken=" + this.sessionToken
                    + "&input=" + search
                    + "&radius=10000";

                var vueApp = this;
                this.filtrando = true
                $.get(url, function (response) {
                    vueApp.places = response.predictions;
                    vueApp.selectedIndex = -1
                    vueApp.filtrando = false
                }, "json");
            },
            selectPlace(place){
                let url = "/get-ubicacion?"
                    + "&placeid=" + place.place_id
                    + "&sessiontoken=" + this.sessionToken;

                if(place.lat != null){
                    // direccion de agenda
                    this.setLocation(place.description, place.lat, place.lng);
                }else {
                    // direccion de google

                    var vueApp = this;
                    $.get(url, function (response) {
                      let ciudad = null
                      console.log(response.result)
                      if(response.result.address_components != null
                      && response.result.address_components.length > 0){
                        let componenteCiudad = response.result.address_components.filter(item => {
                          return item.types.includes("locality")
                        })
                        if(componenteCiudad.length > 0){
                          ciudad = componenteCiudad[0].long_name
                        }
                        else{
                          let estado = response.result.address_components.filter(item => {
                            return item.types.includes("political")
                          })
                          if(estado.length > 0){
                            ciudad = estado[0].long_name
                          }
                        }
                      }
                        vueApp.setLocation(
                            response.result.formatted_address,
                            ciudad,
                            response.result.geometry.location.lat,
                            response.result.geometry.location.lng
                        );
                    }, "json");
                }

                this.sessionToken = (new Date()).getTime();
                // vueApp.$refs.autocomplete.readonly = true;
                this.autocompleteInput = place.description;
                this.$refs.optionlist.style.display = "none";
            },
            setDefaultAddresses(addresses){
                this.defaultAdresses = addresses;
            },
            text(){
                return this.$refs.autocomplete.value;
            },
            setLocation(address, ciudad, lat, lng){
                this.location = {
                    address: address,
                    ciudad: ciudad,
                    lat: lat,
                    lng: lng
                };

                this.autocompleteInput = address;
                this.$emit("input", this.location);
                this.$emit('change');
                this.$forceUpdate();
                this.selectedIndex = -1;
                this.nextFocus();

                // console.log(this.$refs.autocomplete.value)
            },
            nextFocus(){
                let universe = document.querySelectorAll('input, button, select, textarea, a[href]');
                let list = Array.prototype.filter.call(universe, function(item) {return item.tabIndex >= "0"});
                if(list.length > 0){
                    let index = list.indexOf(this.$refs.autocomplete);
                    let elementoFocus = list[index + 1] || list[0];
                    elementoFocus.focus();
                }

            }
        }
    };

</script>


<style scoped lang="scss">
    .google-autocomplete-container{
        display: inline-block;
        position: relative;
        min-width: 200px;
        width: 100%;
        height: 3.5rem;
        padding: 0;

        input{
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 3.5rem;
            border: 1px solid #C9C9C9;
            border-radius: 0.75rem;
            padding-left: 1rem;
            padding-right: 50px;
        }

        input[disabled]{
            background: #fefefe;
        }

        .google-autocomplete-select-pin, .google-autocomplete-reset{
            color: #fff;
            position: absolute;
            right: -1px;
            width: 50px;
            height: 100%;
            top: 0;
            line-height: 40px;
            font-size: 15px;
            text-align: center;
            cursor: pointer;
            .icono{
                color: #747474;
                font-size: 30px;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
            }

          &.disabled{
            cursor: default;
            opacity: 0.8;
          }
        }

        ul{
            display: none;
            position: absolute;
            top: 3.5rem;
            padding: 0;
            margin: 0;
            list-style: none;
            left: 0;
            background: #fff;
            z-index: 1;
            width: 100%;
            border-radius: 4px;
            border-color: transparent;
            box-shadow: 0 4px 37.0999984741px 0 rgba(0, 0, 0, 0.0901960784);

            li{
                position: relative;
                padding: 14px 15px;
                border-bottom: 0.5px solid rgba(0, 0, 0, 0.175);
                color: #EF5949;
                padding-left: 40px;

                .icono{
                    position: absolute;
                    left: 10px;
                    top: 50%;
                    transform: translateY(-50%);
                    font-size: 20px;
                }
            }

            li:hover, li.active{
                background: #EF594925;
                cursor: pointer;
            }

            li span{
                color: #747474;
                font-size: 16px;
            }

            i,svg{
                margin-right: 10px;
            }
        }
    }

    .google-autocomplete-container.form-control input{
        border: 0;
    }

    .hidden{
        display: none !important;
    }

</style>
